import React from 'react'
import { Button } from 'react-bootstrap'
import { Star, StarFill } from 'react-bootstrap-icons'

const FiveStar = ({
    value,
    onChange = () => {}
}) => {
    const buttons = [1, 2, 3, 4, 5]

    const buttonStyle = {
        width: '40px',
        height: '40px',
        borderRadius: '20px',
        fontSize: '1em',
        textAlign: 'center',
    }

    const renderButton = (button, key) => {
        const Icon = value < button ? Star : StarFill
        return (
            <div style={{ padding: '5px'}} key={key}>
                <Button
                    variant='link'
                    onClick={() => onChange(button)}
                >
                    <Icon size={30} />
                </Button>
            </div>
        )
    }

    return (
        <div style={{ paddingTop: '20px', paddingBottom: '20px'}}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around'}}>
                <div style={{ display: 'flex'}}>
                    {buttons.map(renderButton)}
                </div>
            </div>
            <div style={{ textAlign: 'center' }}><small>Click on stars to rate!</small></div>
        </div>
    )
}

export default FiveStar
